// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/sk_b0y/cos1/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/home/sk_b0y/cos1/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

